<template>
  <div class="market-contracts-list-header-sushi__item-2" v-click-outside="onClickOutside">
    <div
      class="market-contracts-list-header-sushi__item-2-text"
      :class="{ 'market-contracts-list-header-sushi__item-2-text--clickable': !forCmsWidget }"
      @click="onMenuToggle"
    >
      {{ title }}
    </div>
    <transition name="market-contracts-list-header-sushi">
      <div class="market-contracts-list-header-sushi__menu" v-if="showMenu">
        <div class="market-contracts-list-header-sushi__menu-inner">
          <div
            class="market-contracts-list-header-sushi__menu-inner-item"
            @click="setOddsMode(true)"
          >
            <div
              class="market-contracts-list-header-sushi__menu-inner-icon"
              :class="{
                'market-contracts-list-header-sushi__menu-inner-icon--empty': !settingShowOdds,
              }"
            ></div>
            <div
              class="market-contracts-list-header-sushi__menu-inner-item-operation"
              :class="{
                'market-contracts-list-header-sushi__menu-inner-item-operation--selected':
                  settingShowOdds,
              }"
            >
              Odds
            </div>
          </div>
          <div
            class="market-contracts-list-header-sushi__menu-inner-item"
            @click="setOddsMode(false)"
          >
            <div
              class="market-contracts-list-header-sushi__menu-inner-icon"
              :class="{
                'market-contracts-list-header-sushi__menu-inner-icon--empty': settingShowOdds,
              }"
            ></div>
            <div
              class="market-contracts-list-header-sushi__menu-inner-item-operation"
              :class="{
                'market-contracts-list-header-sushi__menu-inner-item-operation--selected':
                  !settingShowOdds,
              }"
            >
              Trade Prices
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script src="./market-contracts-list-header-sushi-item2.js"></script>
